export default "__VITE_ASSET__b497f5ff__"